import {SupportProduct} from "@/model/support/SupportProduct";

export class ConfirmOrderPreparationRequest {
  orderNumber: string;
  storeId: string;
  driveId: string;
  type: string;
  deliverySiteId: string;
  products: SupportProduct[];
}
